import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Button, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import Select from "react-select";

const schema = yup.object().shape({
	name:      yup.string().min(3).required(),
	change_id: yup.number().required(),
});

export default function DialogScenarioCopyFromChange(props) {

	const { onClose, setup } = props;
	const { Formik }         = formik;

	const [status, setStatus] = useState({ sent: null, message: '' });

	const { open, changeOptions, defaultValue, projectid, scenarioid, onFinish } = setup;

	const handleClose = (result) => {
		setStatus({ sent: null, message: '' });
		onClose(result);
	};

	const handleSubmit = (data) => {
		setStatus({ sent: false, success: false, message: 'Saving...' });

		atlasApi.copyScenarioFromChange(projectid, scenarioid, data.change_id, data.name)
			.then((res) => {
				if (res.new_scenario_id) {
					setStatus({ sent: true, success: true, message: 'Scenario created successfully' });
					setTimeout(() => {
						if (onFinish)
							onFinish(res);
						else
							window.location.href = '/pages/project/' + projectid + '?scenarioid=' + res.new_scenario_id;
					}, 1500);
				} else {
					setStatus({ sent: true, success: false, message: 'Error creating scenario' });
				}
			}).catch(() => {
				setStatus({ sent: true, success: false, message: 'Error creating scenario' });
			});
	};

	return (
		<Modal show={open} onHide={handleClose} centered className="copy-dialog">
			<Modal.Header closeButton>
				<Modal.Title>Copy to scenario</Modal.Title>
			</Modal.Header>

			<Formik
				validationSchema={schema}
				onSubmit={handleSubmit}
				initialValues={{ name: '', change_id: defaultValue?.value ?? null }}
			>
				{({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
					<Form noValidate onSubmit={handleSubmit}>
						{status.sent === null ? (
							<React.Fragment>
								<Modal.Body>
									<Row className="mb-3">
										<Form.Group as={Col} md="12" controlId="copyFromChange">
											<Form.Label>Copy from</Form.Label>
											<Select
												name="change_id"
												options={changeOptions}
												defaultValue={defaultValue}
												onChange={(opt) => setFieldValue('change_id', opt?.value ?? null)}
												isSearchable={true}
												placeholder="Select version"
												isInvalid={!!errors.change_id}
											/>
										</Form.Group>
									</Row>
									<Row className="mb-3">
										<Form.Group as={Col} md="12" controlId="copyScenarioName">
											<Form.Label>New scenario name</Form.Label>
											<Form.Control
												type="text"
												name="name"
												placeholder="Input scenario name"
												value={values.name}
												onChange={handleChange}
												isValid={touched.name && !errors.name}
												isInvalid={touched.name && !!errors.name}
											/>
											<Form.Control.Feedback type="invalid">
												Please provide a valid scenario name (min. 3 characters).
											</Form.Control.Feedback>
										</Form.Group>
									</Row>
								</Modal.Body>
								<Modal.Footer className="border-0">
									<Button variant="outline-secondary" onClick={handleClose}>Cancel</Button>
									<Button variant="dark" type="submit">Copy to scenario</Button>
								</Modal.Footer>
							</React.Fragment>
						) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{status.sent
											? (status.success
												? <i className="ri-checkbox-circle-line text-success" />
												: <i className="ri-error-warning-line text-warning" />)
											: <Spinner animation="border" variant="info" className="mt-5" />
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{status.message}
									</Col>
								</Row>
							</Modal.Body>
						)}
					</Form>
				)}
			</Formik>
		</Modal>
	);
}
